module.exports = __webpack_public_path__ + "static/media/attendees.ca7e66ea.svg";